import React from 'react'
import config from '../../config'

function SocialPreview({
  social = 'facebook',
  imageUrl = 'https://placehold.co/800x400?text=Meta+Image',
  title = 'example title',
  description = 'example description',
}) {
  // Default values
  const defaults = {
    social: 'facebook',
    imageUrl: 'https://placehold.co/800x400?text=Meta+Image',
    title: 'example title',
    description: 'example description',
  }

  // Helper function to check if a value is empty
  const isEmpty = (value) => {
    return !value || (typeof value === 'string' && value.trim() === '')
  }

  // Use defaults if values are empty (null, undefined, or empty string)
  const normalizedSocial = isEmpty(social) ? defaults.social : social
  const normalizedImageUrl = isEmpty(imageUrl) ? defaults.imageUrl : imageUrl
  const normalizedTitle = isEmpty(title) ? defaults.title : title
  const normalizedDescription = isEmpty(description) ? defaults.description : description

  // Extract domain from REACT_APP_SITO_URL for display (e.g., "www.lagodigardacamping.com")
  const domain = config.sitoUrl.replace(/^https?:\/\//, '').replace(/\/.*$/, '')

  // Normalize social prop to lowercase
  const socialType = normalizedSocial.toLowerCase()

  // Render Facebook preview
  const renderFacebook = () => (
    <div>
      <div style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 600, color: '#65686C' }}>Facebook</div>
      <div style={{ width: '524px', maxWidth: '100%', margin: '0 auto' }}>
        <div style={{ backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
          <div style={{ width: '100%', position: 'relative', height: 0, paddingTop: '52.5%' }}>
            <img
              style={{
                height: '100%',
                width: '100%',
                position: 'absolute',
                top: 0,
                objectFit: 'cover',
                display: 'block',
              }}
              src={normalizedImageUrl}
              alt="Facebook meta image"
            />
          </div>
        </div>
        <div
          style={{
            wordBreak: 'break-word',
            backgroundColor: '#F0F2F5',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '10px',
            paddingBottom: '6px',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            fontFamily:
              'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI Historic", "Segoe UI", Helvetica, Arial, sans-serif',
          }}
        >
          <div
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: '13px',
              textTransform: 'uppercase',
              lineHeight: '12px',
              color: '#65686C',
              marginBottom: '5px',
            }}
          >
            {domain}
          </div>
          <div
            style={{
              display: 'block',
              borderCollapse: 'separate',
              userSelect: 'none',
              overflow: 'hidden',
              wordBreak: 'break-word',
              textAlign: 'left',
              borderSpacing: '0px',
            }}
          >
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '17px',
                fontWeight: 600,
                lineHeight: '21px',
                color: '#080809',
              }}
            >
              {normalizedTitle}
            </div>
            {normalizedDescription && (
              <div
                style={{
                  fontSize: '15px',
                  lineHeight: '20px',
                  color: '#606770',
                  marginTop: '4px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {normalizedDescription}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )

  // Render X (Twitter) preview
  const renderX = () => (
    <div>
      <div style={{ marginBottom: '8px', fontSize: '14px', fontWeight: 600, color: '#65686C' }}>X (Twitter)</div>
      <div
        style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        }}
      >
        <div
          style={{
            position: 'relative',
            width: '438px',
            maxWidth: '100%',
            overflow: 'hidden',
            borderRadius: '0.85714em',
            border: '1px solid #e1e8ed',
            lineHeight: '1.3em',
            color: 'black',
            margin: '0 auto',
          }}
        >
          <div style={{ backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <div style={{ width: '100%', position: 'relative', height: 0, paddingTop: '52.33%' }}>
              <img
                style={{
                  height: '100%',
                  width: '100%',
                  position: 'absolute',
                  top: 0,
                  objectFit: 'cover',
                  display: 'block',
                }}
                src={normalizedImageUrl}
                alt="X preview"
              />
            </div>
          </div>
          <div
            style={{
              position: 'absolute',
              bottom: '12px',
              left: '12px',
              fontSize: '13px',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.77)',
              paddingLeft: '8px',
              paddingRight: '8px',
              borderRadius: '4px',
              textOverflow: 'ellipsis',
              maxWidth: 'calc(100% - 1.5rem)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {normalizedTitle}
          </div>
        </div>
        <div
          style={{
            color: '#536471',
            fontSize: '13px',
            width: '438px',
            maxWidth: '100%',
            margin: '0 auto',
          }}
        >
          From {domain}
        </div>
      </div>
    </div>
  )

  // Render based on social prop using switch case
  switch (socialType) {
    case 'x':
    case 'twitter':
      return renderX()
    case 'facebook':
    default:
      return renderFacebook()
  }
}

export default SocialPreview
